import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
interface Buyer {
  name: string;
  location: string;
  avatar: string;
}
const buyers: Buyer[] = [{
  name: 'James M.',
  location: 'London, United Kingdom',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Sofia R.',
  location: 'Madrid, Spain',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Lucas P.',
  location: 'São Paulo, Brazil',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Emma W.',
  location: 'Sydney, Australia',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Daniel K.',
  location: 'Toronto, Canada',
  avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Marco B.',
  location: 'Milan, Italy',
  avatar: 'https://images.unsplash.com/photo-1542178243-bc20204b769f?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Aisha N.',
  location: 'Dubai, UAE',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Carlos G.',
  location: 'Mexico City, Mexico',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Nina S.',
  location: 'Berlin, Germany',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=120&auto=format&fit=crop'
}, {
  name: 'Liam O.',
  location: 'Dublin, Ireland',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=120&auto=format&fit=crop'
}];
const minutesAgoOptions = [2, 4, 5, 7, 9, 11, 14, 18];
function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(3);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    let cycleTimeout: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setBuyer(pickRandom(buyers));
      setMinutesAgo(pickRandom(minutesAgoOptions));
      setVisible(true);
      // Keep it on screen for ~6 seconds.
      hideTimeout = setTimeout(() => setVisible(false), 6000);
      // Schedule the next popup 30–40s after this one appears.
      const nextDelay = 30000 + Math.random() * 10000;
      cycleTimeout = setTimeout(showOne, nextDelay);
    };
    // First popup shortly after load.
    const initial = setTimeout(showOne, 8000);
    return () => {
      clearTimeout(initial);
      clearTimeout(hideTimeout);
      clearTimeout(cycleTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-158">
      {visible && buyer && <motion.div initial={{
      opacity: 0,
      y: 24,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-[60] w-[calc(100%-2rem)] max-w-sm" role="status" aria-live="polite" data-id="element-159">
          <div className="flex items-center gap-3 rounded-xl border border-zinc-700/70 bg-zinc-900/95 backdrop-blur-md p-3 pr-4 shadow-2xl shadow-black/50" data-id="element-160">
            <div className="relative shrink-0" data-id="element-161">
              <img src={buyer.avatar} alt={buyer.name} className="w-11 h-11 rounded-full object-cover border border-zinc-700" data-id="element-162" />
              <span className="absolute -bottom-1 -right-1 bg-emerald-500 rounded-full p-0.5 border-2 border-zinc-900" data-id="element-163">
                <BadgeCheck className="w-3 h-3 text-white" data-id="element-164" />
              </span>
            </div>

            <div className="min-w-0 flex-1" data-id="element-165">
              <div className="flex items-center gap-1.5" data-id="element-166">
                <span className="text-[11px] font-bold uppercase tracking-wider text-emerald-400" data-id="element-167">
                  Verified Purchase
                </span>
              </div>
              <p className="text-sm text-white font-semibold leading-tight truncate" data-id="element-168">
                {buyer.name}{' '}
                <span className="font-normal text-zinc-400" data-id="element-169">
                  from {buyer.location}
                </span>
              </p>
              <p className="text-[11px] text-zinc-500 leading-tight" data-id="element-170">
                Just got Functional &amp; Cross Ready · {minutesAgo} min ago
              </p>
            </div>

            <button onClick={() => setVisible(false)} aria-label="Dismiss notification" className="shrink-0 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-171">
              <X className="w-4 h-4" data-id="element-172" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}